module.exports = __webpack_public_path__ + "static/logo-bed7245aa9121547479c2fc50b601792.png";